export default __webpack_public_path__ + "static/media/cardbeneficios.46647bd1.png";